/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/05/22
 */

import React from 'react';
import { ArrayLayoutProps, UISchemaElement } from '@jsonforms/core';
import { Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import { namedMemo } from '@/utils/namedMemo';
import { JsonFormsDispatch } from '@jsonforms/react';

export type ArrayLayoutToolbarProps = Pick<
    ArrayLayoutProps,
    'addItem' | 'label' | 'path' | 'schema' | 'enabled' | 'uischema' | 'errors'
> & {
    isReadonly?: boolean;
};

const ChakraListWithDetailLayoutToolBar = namedMemo(
    'ChakraListWithDetailLayoutToolBar',
    ({ label, errors, uischema }: ArrayLayoutToolbarProps) => {
        const emptyTraining = errors.includes('must NOT have fewer than 1 items');
        const emptyTrainingError =
            'Please enter any training items below that you would like to complete during the workplan year';
        const descriptionElements = uischema.options?.descriptionElements;

        return (
            <Flex alignItems="center" justifyContent="space-between" border={'1px solid'} borderColor="gray.200" p={6}>
                <Grid justifyContent={'flex-start'} alignItems={'center'}>
                    <GridItem display={{ md: 'flex' }}>
                        <Text fontSize="lg" fontWeight="bold" alignSelf={'center'} pr={3}>
                            {label}
                        </Text>
                        {emptyTraining && (
                            <Text role="presentation" aria-live="polite" style={{ color: 'red' }}>
                                * {emptyTrainingError}
                            </Text>
                        )}
                        {Array.isArray(descriptionElements) &&
                            descriptionElements.map((desc: UISchemaElement, i: number) => {
                                return <JsonFormsDispatch uischema={desc} key={i} />;
                            })}
                    </GridItem>
                </Grid>
            </Flex>
        );
    },
);
export default ChakraListWithDetailLayoutToolBar;
